
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getMonthInitialAndDay } from '@/features/common/helpers/moment';

@Component
export default class SmallCalendar extends Vue {
  @Prop({ required: true }) date!: string;

  @Prop({ required: false, default: false }) muted!: boolean;

  @Prop({ default: false }) today!: boolean;

  get monthAndDay(): { month: string, day: number} | null {
    return getMonthInitialAndDay(this.date);
  }
}
